<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup bb001000i calculate
 * @created at      :   2023/03/10
 * @created by      :   ANS874 – quanhvm@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import { mapMutations } from 'vuex';
// import repository from '@/utils/repository';
// import messages, { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
// import helpers from '@/utils/helpers';
/**
 * Define component for popup ba001000i calculate
 */
var SamplePopupSearch = {
    template: template,
    props: {
        onSelected: Function,
        initData: Object,
        isShowFooter: Boolean
    },
    created() {},
    data() {
        return {
            search: '',
            resultSearch: [],
            date_report: ''
        };
    },
    computed: {
        initObject() {
            return this.initData;
        }
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage'])
    }
};
export default SamplePopupSearch;
</script>
